import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Link } from "react-router-dom";
import { X } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { loadQuest, saveQuest } from "@/lib/quest";

const input = "h-11 rounded-full border border-navy/15 bg-white px-4 text-sm focus:outline-none focus:ring-4 focus:ring-aqua";

export const useDiscount = (open) => {
  const [code, setCode] = useState("");
  const [email, setEmail] = useState("");
  const [applied, setApplied] = useState(null);
  useEffect(() => {
    const q = loadQuest();
    if (open && q && !applied) { setCode(q.code); setEmail(q.email); }
  }, [open, applied]);
  return { code, setCode, email, setEmail, applied, setApplied };
};

export const discounted = (price, pct) => (pct ? Math.round(Math.round(price * 100) * (100 - pct) / 100) / 100 : price);

export const DiscountBox = ({ d }) => {
  const [busy, setBusy] = useState(false);
  const apply = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/discount/check", { code: d.code, email: d.email });
      d.setApplied(data);
      saveQuest({ code: data.code, email: d.email });
      toast.success(`${data.pct}% off applied.`);
    } catch (e) { toast.error(errMsg(e, "That code didn't stick.")); }
    finally { setBusy(false); }
  };
  if (d.applied) return (
    <div data-testid="cart-discount-applied" className="flex items-center justify-between rounded-xl border border-navy/15 bg-aqua px-4 py-2 text-sm font-semibold">
      <span>{d.applied.code}: {d.applied.pct}% off ({d.email})</span>
      <button data-testid="cart-discount-remove" onClick={() => d.setApplied(null)} aria-label="Remove code"><X className="h-4 w-4" /></button>
    </div>
  );
  return (
    <div data-testid="cart-discount-box" className="space-y-2">
      <label className="font-mono text-xs uppercase tracking-widest">Discount code</label>
      <div className="grid grid-cols-2 gap-2">
        <input data-testid="cart-discount-code-input" value={d.code} onChange={(e) => d.setCode(e.target.value)} placeholder="Code" className={input} />
        <input data-testid="cart-discount-email-input" type="email" value={d.email} onChange={(e) => d.setEmail(e.target.value)} placeholder="your@email.com" className={input} />
      </div>
      <button data-testid="cart-discount-apply" onClick={apply} disabled={busy || !d.code.trim() || !d.email.trim()} className="text-sm font-semibold underline underline-offset-4 disabled:opacity-40">{busy ? "Checking..." : "Apply code"}</button>
      <p className="text-xs text-slate-600">One-time orders only, one use per email.</p>
    </div>
  );
};
